import { useMemo } from "react";
import useQuery from "hooks/useQuery";
import RemoteVideoService from "services/RemoteVideoService";
import type { MuxMeasurementVideo } from "types";
import useQueryStatusBuilder from "hooks/useQueryStatusBuilder";
import type { ThumbnailOptions } from "services/RemoteVideoService/RemoteVideoService";

function useGetVideoThumbnailUrl(video: MuxMeasurementVideo, options?: ThumbnailOptions) {
  const opts = useMemo(() => options ?? { width: 30, height: 30 }, [options]);

  const key = useMemo(() => {
    if (!video.mp4Ready) return null;
    return ["RemoteVideoService.getThumbnailUrl", video.playbackId, opts] as const;
  }, [video.mp4Ready, video.playbackId, opts]);

  const { data, isLoading, error } = useQuery(key, ([_, id, options]) =>
    RemoteVideoService.getThumbnailUrl(id, options)
  );

  const queryStatus = useQueryStatusBuilder({ isError: !!error, isLoading });
  const status = useMemo(() => (video.mp4Ready ? queryStatus : "fetching"), [queryStatus, video.mp4Ready]);

  return useMemo(() => ({ status, src: data }), [status, data]);
}

export default useGetVideoThumbnailUrl;
